@if(!isLoading) {
<div class="ion-padding content-width">
  <!-- <div *ngIf="hasPendingRequests()" class="pending-request-box ion-padding content-width ">
    <p>{{getPendingRequestsCount()}} player requested to claim profile</p>
    <ion-icon name="information" size="large"></ion-icon>
  </div> -->
  <div class="admin-count-wrapper">
    <div class="admin-count">{{teamAdmins?.owners?.length + teamAdmins?.coaches?.length}}</div>
  </div>
  <ion-list *ngIf="(teamAdmins?.owners?.length || teamAdmins?.coaches?.length); else noAdmins">
    <!-- Loop through owners -->
    <ion-item *ngFor="let ta of teamAdmins.owners; let i = index;">
      <ion-avatar slot="start">
        <img *ngIf="ta?.profile_image; else defaultAvatar" [src]="ta.profile_image" alt="Profile Image" />
      </ion-avatar>

      <ng-template #defaultAvatar>
        <img [src]="avatarImage" />
      </ng-template>

      <ion-label>
        {{ ta?.first_name }} {{ ta?.last_name }}
        <p>{{ ta?.phone }}</p>
      </ion-label>

      <!-- ❌ Claim hidden for owners -->
      <!-- nothing here -->

      <ion-button *ngIf="isOwner" slot="end" (click)="removeAdmin(i)" color="danger" fill="clear">
        <ion-icon *ngIf="!removingAdmin" slot="icon-only" name="remove-circle"></ion-icon>
        <ion-spinner *ngIf="removingAdmin" name="crescent"></ion-spinner>
      </ion-button>
    </ion-item>

    <!-- Loop through coaches -->
    <ion-item class="content-width" *ngFor="let ta of teamAdmins.coaches; let i = index;">
      <ion-avatar slot="start">
        <img *ngIf="ta?.profile_image; else defaultAvatar" [src]="ta.profile_image" alt="Profile Image" />
      </ion-avatar>

      <ng-template #defaultAvatar>
        <ion-avatar>
          <ion-icon name="person-circle-outline" size="large"></ion-icon>
        </ion-avatar>
      </ng-template>

      <ion-label>
        {{ ta?.first_name }} {{ ta?.last_name }}
        <p>{{ ta?.phone }}</p>
      </ion-label>

      <!-- ✅ Claim button only for coaches -->
      <!-- <ion-button *ngIf="!ta?.status && !isOwner" class="follow-badge" slot="end" (click)="claimAdmin(i)">
        Claim
      </ion-button> -->

      <!-- <ion-button class="follow-badge" slot="end"
        *ngIf="(ta?.status === 'pending' && isOwner) || (ta?.claimedBy === authUser?._id && ta?.status === 'pending')"
        (click)="isOwner ? approveAdmin(i) : revokeAdminRequest(i)">
        {{ isOwner ? 'Approve' : 'Revoke' }}
      </ion-button> -->

      <ion-button *ngIf="isOwner" slot="end" (click)="removeAdmin(i)" color="danger" fill="clear">
        <ion-icon *ngIf="!removingAdmin" slot="icon-only" name="remove-circle"></ion-icon>
        <ion-spinner *ngIf="removingAdmin" name="crescent"></ion-spinner>
      </ion-button>
    </ion-item>
  </ion-list>

  <ng-template #noAdmins>
    <ion-item>
      <ion-label>{{'Add your coaching staff to manage players, lineups, and live scoring. Click below to get started.' |
        translate}}</ion-label>
    </ion-item>
  </ng-template>
</div>

<div *ngIf="!isOwner" class="content-width team-join-center">
  <ion-label *ngIf="!isOwner && (teamAdmins?.owners?.length || teamAdmins?.coaches?.length)"
    class="team-join-text">{{'Add your coaching staff to manage
    players, lineups, and live scoring. Click below
    to get started.' |
    translate}}</ion-label>
  <ion-button class="follow-badge" slot="end" (click)="displayStaffJoin()">
    I am a staff member
  </ion-button>
</div>
}


@if(isLoading) {
<div class="ion-padding content-width" *ngFor="let item of [0, 1, 2]">
  <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>
}